import React from 'react';
import { createUser, updateResponse, getRoles, getPermission } from "../../api/userapi";
import { getAllClubs } from "../../api/clubapi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col } from 'reactstrap';
import CustomDatePicker from '../CustomDatePicker';
import PopupError from '../PopupError';
import FormValidator from '../FormValidation';
import '../css/EditCreate.css';
import InputFeedback from '../utils/InputFeedback';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'
class UserCreate extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/users');
        this.props.route.history.push(this.props.route.match.url);
        this.permission = getPermission();
        this.validator = new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            // {
            //     field: 'telephone',
            //     method: this.isTelephone,
            //     validWhen: true,
            //     message: 'Must be valid phone number.'
            // },            
            {
                field: 'roleName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'clubName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
        ])
        this.state = {
            user: {
                firstName: '',
                lastName: '',
                startDate: '',
                endDate: '',
                email: '',
                clubName: '',
                roleName: '',
                telephone: '',
                roleId: '',
                clubId: '',
                ftpNotify: true
            },
            roles: [],
            clubs: [],
            ftpNotify: '',
            cancel: false,
            saved: false,
            error: false,
            loading: false,
            errorMessage: [],
            userId: '',
            validation: this.validator.valid()
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    isTelephone = (state) => (state === "" || state.match(/^\D?(\d{3,5})\D?\D?(\d{3,5})\D?(\d{4,5})$/));


    componentDidMount() {
        this.props.getAllClubs(function (result, _this) { _this.getDataClub(result, _this) }, this);
        this.props.getRoles(function (result, _this) { _this.getData(result, _this) }, this);
    }

    renderRoleNames() {
        let roles = this.state.roles;

        return roles.map((role, index) => {
            return (
                <option id={role.roleId} key={index}>{role.role}</option>
            );
        });
    }

    renderClubNames() {
        let clubs = this.state.clubs;

        return clubs.map((club, index) => {
            return (
                <option id={club.clubId} key={index}>{club.name}</option>
            );
        });
    }

    getData(data, _this) {
        //sets the user.role name and user.roleId to first array of clubs
        if (data !== undefined) {
            let roles = data.data.data;
            if (roles.length !== 1) {
                roles.unshift("");
            }
            _this.setState({
                roles: roles,
            })
        }
    }

    getDataClub(data, _this) {
        //sets the user.role name and user.roleId to first array of clubs

        if (data != undefined) {
            let clubs = data.data.data;
            if (clubs.length !== 1) {
                clubs.unshift("");
                _this.setState({
                    clubs: clubs,
                })
            }
        }
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    this.setState(state => ({
                        saved: true,
                        userId: result.data.data.userId
                    }));
                    console.log(result.data.data.userId, "data");
                    //This is backend validation error handling
                } else if (result.data.success == false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    var unPush = this.state.user
                    this.setState({ error: true, errorMessage: errorList, user: unPush, loading: false })
                }
                //This is database error handling
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    var unPush = this.state.user
                    this.setState({ error: true, errorMessage: message, user: unPush, loading: false });
                }
                this.props.updateResponse("");
            }
        }
    }

    handleFormSubmit = event => {
        event.preventDefault();

        var updVal = this.state.user;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ user: updVal }, () => {
            const validation = this.validator.validate(this.state.user);
            this.setState({ validation });
            this.submitted = true;
            if (validation.isValid) {
                // handle actual form submission here
                this.setState({ loading: true })
                this.props.createUser(updVal);
            }
        });
    }

    //Redirects to club list
    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
        input.value = input.value.length > input.maxLength && input.maxLength > 0 ? input.value.slice(0, input.maxLength) : input.value;
    }

    //Closes the popup when the X is clicked or click outside the modal.
    closeModal() {
        this.setState({ error: false });
    }

    render() {
        const user = this.state.user;
        const loading = this.state.loading;
        //Redirects to user list when cancel button is triggered
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/users`,
                }}
            />;
        }
        //Redirects to user list when save is succesful
        if (this.state.saved) {
            return <Redirect
                to={{
                    pathname: `/secure/userEdit/${this.state.userId}`,
                    state: { userId: this.state.userId }
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.user) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';

        return (

            <div className="card">
                <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >
                    <PopupError
                        open={this.state.error}
                        onClose={this.closeModal}
                        onClick={this.closeModal}
                        errorMessage={this.state.errorMessage} />

                    <div className="card-header text-center"> Add User</div>
                    <div className="card-body fs-12">
                        <Form onSubmit={this.handleSubmit}>
                            <RequiredFieldNotation />
                            <div className="row">
                                <div className="col-md-6">
                                    <Col className={`${validation.lastName.isInvalid ? 'has-error' : ''}`}>
                                        <Label htmlFor='lastName' className="required-hint mt-4"><strong>Last name</strong></Label>
                                        <Input
                                            type="input"
                                            id='lastName'
                                            maxLength="30"
                                            className="input-editable"
                                            value={user.lastName}
                                            onChange={(e) => { this.isInvalid(e); var x = user; x.lastName = e.target.value; this.setState({ user: x }) }} />
                                        <span className="help-block">{validation.lastName.message}</span>
                                    </Col>
                                    <Col className={`${validation.firstName.isInvalid ? 'has-error' : ''}`}>
                                        <Label htmlFor='firstName' className="required-hint mt-4"><strong>First name</strong></Label>
                                        <Input
                                            type="input"
                                            id="firstName"
                                            name="firstName"
                                            maxLength="30"
                                            className="input-editable"
                                            value={user.firstName}
                                            onChange={(e) => {
                                                this.isInvalid(e);
                                                var x = user; x.firstName = e.target.value; this.setState({ user: x })
                                            }} />
                                        <span className="help-block">{validation.firstName.message}</span>
                                    </Col>
                                    <Col
                                        className={`${validation.email.isInvalid ? 'has-error' : ''}`}
                                    >
                                        <Label htmlFor='email' className="required-hint mt-4"><strong>Email</strong></Label>
                                        <Input
                                            type="email"
                                            maxLength="320"
                                            name="email"
                                            id='email'
                                            autoComplete="off"
                                            className="input-editable"
                                            value={user.email}
                                            onChange={(e) => {
                                                this.isInvalid(e);
                                                var x = user; x.email = e.target.value; this.setState({ user: x })
                                            }} />
                                        <InputFeedback feedbackText={feedback.email} id='email' />
                                        <span className="help-block">{validation.email.message}</span>
                                    </Col>

                                    <Col>
                                        <Label htmlFor='telephone' className="mt-4"><strong>Telephone</strong></Label>
                                        <Input
                                            type="number"
                                            name="telephone"
                                            id='telephone'
                                            maxLength="10"
                                            className="input-editable"
                                            value={user.telephone}
                                            onChange={(e) => {
                                                this.isInvalid(e);
                                                var x = user; x.telephone = e.target.value; this.setState({ user: x });
                                            }} />
                                        <InputFeedback feedbackText={feedback.telephone} id='telephone' />
                                    </Col>
                                </div>
                                <div className="col-md-6">
                                    <Col className={`${validation.clubName.isInvalid ? 'has-error' : ''}`}>
                                        <Label htmlFor='clubName' className="required-hint mt-4"><strong>Club</strong></Label>
                                        <label className="select">
                                            <select
                                                id="clubName"
                                                name="clubName"
                                                className="form-control input-editable"
                                                value={user.clubName}
                                                onChange={(e) => {
                                                    var x = user;
                                                    x.clubName = e.target.value;
                                                    x.clubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                    this.setState({ user: x })
                                                }}
                                            >
                                                {this.renderClubNames()}
                                            </select>
                                        </label>
                                        <span className="help-block">{validation.clubName.message}</span>
                                    </Col>
                                    <Col className={`${validation.roleName.isInvalid ? 'has-error' : ''}`}>
                                        <Label htmlFor='roleName' className="required-hint mt-4"><strong>Role</strong></Label>
                                        <label className="select sm-input">
                                            <select
                                                id="roleName"
                                                name="roleName"
                                                value={user.roleName}
                                                className="form-control input-editable"
                                                onChange={(e) => {
                                                    var x = user;
                                                    x.roleName = e.target.value;
                                                    x.roleId = e.target[e.target.selectedIndex].getAttribute('id');
                                                    this.setState({ user: x })
                                                }}
                                            >
                                                {this.renderRoleNames()}
                                            </select>
                                        </label>
                                        <span className="help-block">{validation.roleName.message}</span>
                                    </Col>
                                    <Col >
                                        <Label htmlFor='ftpNotify' className="mt-4"><strong>Receives FTP Notifications</strong></Label>
                                        <label className="select sm-input">
                                            <select
                                                id="ftpNotify"
                                                name="ftpNotify"
                                                value={this.state.ftpNotify}
                                                className="form-control input-editable"
                                                onChange={(e) => {
                                                    var x = this.state.ftpNotify;
                                                    x = e.target.value;
                                                    var y = user;
                                                    y.ftpNotify = e.target[e.target.selectedIndex].getAttribute('value');
                                                    this.setState({ user: y, ftpNotify: x })
                                                }}
                                            >
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </label>
                                    </Col>
                                    <Row>
                                        <div className="col-md-6">
                                            <Col className={`${validation.startDate.isInvalid ? 'has-error' : ''}`}>
                                                <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                                <CustomDatePicker
                                                    id="startDate"
                                                    readOnly={false}
                                                    defValue={!user.startDate ? "" : user.startDate.substring(0, 10)}
                                                    label="Start Date"
                                                    overlayClass="location-datepicker-overlay"
                                                />
                                                <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            </Col>
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <Col>
                                                <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                                <CustomDatePicker
                                                    id="endDate"
                                                    readOnly={false}
                                                    defValue={!user.endDate ? "" : user.endDate.substring(0, 10)}
                                                    label="End Date"
                                                    overlayClass="location-datepicker-overlay"
                                                />
                                            </Col>
                                        </div>
                                    </Row>
                                    <div className="text-right float-bottom">
                                        <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                        <Button type="submit" onClick={e => this.handleFormSubmit(e)} className="save-btn">SAVE</Button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </LoadingOverlay>
            </div >
        );
    }
}
export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            users: state.data.users,
            roles: state.data.roles,
            clubs: state.data.clubs
        }
    },
    dispatch => ({
        createUser: (user) => { dispatch(createUser(user)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getRoles: (callback, context) => { dispatch(getRoles(callback, context)) },
        getAllClubs: (callback, context) => { dispatch(getAllClubs(callback, context)) }
    }
    )
)(UserCreate);